module.exports = __webpack_public_path__ + "static/media/defined.a24737da.png";